import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'
import {
  IAccruedSickHour,
  IAccuredTotalSickHours,
  IGetAccruedSickHoursParams,
  IPostSickHourForUserParams,
  IPostAccruedSickHourParams,
  IPutAccruedSickHourParams,
  IAccruedSickHoursOverview,
  IGetAccruedSickHoursOverviewParams,
} from 'models/AccruedSickHour'

export class AccruedSickHoursApi {
  constructor(private axios: AxiosService) {}

  getAccruedSickHours = async (params?: IGetAccruedSickHoursParams) => {
    const response = await this.axios.get<IPayload<IAccuredTotalSickHours[]>>(
      Endpoints.getAccruedSickHours,
      params,
    )
    return response
  }

  getAccruedSickHoursOverview = async (
    params?: IGetAccruedSickHoursOverviewParams,
  ) => {
    const response = await this.axios.get<
      IPayload<IAccruedSickHoursOverview[]>
    >(Endpoints.getAccruedSickHoursOverview, params)
    return response
  }

  getAccruedSickHour = async (id: number) => {
    const response = await this.axios.get<IPayload<IAccruedSickHour>>(
      Endpoints.getAccruedSickHour(id),
    )
    return response
  }

  postAccruedSickHour = async (params: IPostAccruedSickHourParams) => {
    const response = await this.axios.post<IPayload<IAccruedSickHour>>(
      Endpoints.postAccruedSickHour,
      params,
    )
    return response
  }

  putAccruedSickHour = async (
    id: number,
    params: IPutAccruedSickHourParams,
  ) => {
    const response = await this.axios.put<IPayload<IAccruedSickHour>>(
      Endpoints.putAccruedSickHour(id),
      params,
    )
    return response
  }

  deleteAccruedSickHour = async (id: number) => {
    const response = await this.axios.delete<{}>(
      Endpoints.deleteAccruedSickHour(id),
    )
    return response
  }

  updateAccruedHoursForUser = async (params: IPostSickHourForUserParams) => {
    const response = await this.axios.post<IPayload<IAccruedSickHour>>(
      Endpoints.updateSickHoursForUser,
      params,
    )
    return response
  }
}
